<div
  class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-6 sm:px-10 border-b bg-card dark:bg-transparent"
>
  <div class="flex-1 min-w-0">
    <app-breadcrumb class="mb-1" *ngIf="showBreadcrumb"></app-breadcrumb>
    <div class="flex flex-col md:flex-row justify-between md:items-center">
      <h2
        class="text-xl m-0 md:text-2xl font-bold md:font-extrabold tracking-tight leading-7 md:leading-10 truncate"
      >
        {{ name }}
      </h2>

      <!--    <button class="bottone-save" [class.disabled]="buttonDisabled" (click)="saveConfig()">-->
      <!--        <mat-icon style="padding: 1px;margin-right: 2px; margin-bottom: 2px; color:white;" svgIcon="mat_solid:save">-->
      <!--        </mat-icon>-->
      <!--        Save-->
      <!--    </button>-->

      <button
        class="header-action-button"
        *ngIf="showButton"
        [disabled]="buttonDisabled"
        mat-flat-button
        [color]="'primary'"
        (click)="triggerAction()"
      >
        <mat-icon [svgIcon]="'mat_solid:' + icon"></mat-icon>
        <span class="ml-2 mr-1">{{ buttonText }}</span>
      </button>

      <div
        class="w-full md:w-60 relative flex self-start pt-2 pb-1 pl-5 pr-4 cursor-pointer overflow-hidden rounded-xl bg-accent-100 mt-4 md:mb-0 md:mt-0"
        matRipple
        [matMenuTriggerFor]="projectsMenu"
        *ngIf="showDashboardAreaMenu"
      >
        <div class="flex items-center w-full justify-between">
          <div class="overflow-hidden">
            <div class="font-medium leading-6 truncate">
              {{ selectedDashboardArea }}
            </div>
          </div>
          <div class="flex items-center justify-center pl-2">
            <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_solid:chevron-down'"
            ></mat-icon>
          </div>
        </div>
        <mat-menu #projectsMenu="matMenu" [xPosition]="'before'">
          <button mat-menu-item (click)="changeDashboardArea('Generale')">
            Generale
          </button>
          <button
            mat-menu-item
            (click)="changeDashboardArea('Dettaglio Batch')"
          >
            Dettaglio Batch
          </button>
        </mat-menu>
      </div>

      <div
        class="w-full md:w-60 relative flex self-start pt-2 pb-1 pl-5 pr-4 cursor-pointer overflow-hidden rounded-xl bg-accent-100 mt-4 md:mb-0 md:mt-0"
        matRipple
        *ngIf="showMainMenu"
        [matMenuTriggerFor]="mainMenu"
      >
        <div class="flex items-center w-full justify-between">
          <div class="overflow-hidden">
            <div class="font-medium leading-6 truncate">
              {{ selectedMenuItem }}
            </div>
          </div>
          <div class="flex items-center justify-center pl-2">
            <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_solid:chevron-down'"
            ></mat-icon>
          </div>
        </div>
        <mat-menu #mainMenu="matMenu" [xPosition]="'before'">
          <button
            mat-menu-item
            (click)="navigateMenu('Applications', '/lista')"
          >
            Applications
          </button>
          <button
            mat-menu-item
            (click)="navigateMenu('Dashboard', '/dashboard')"
          >
            Dashboard
          </button>
          <button
            mat-menu-item
            (click)="navigateMenu('Dashboard', '/partner-evaluations')"
          >
            Valutazioni Partners
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
